const type1 = '#66D4DB';
const type2 = '#247690';
const type3 = '#979797';
export default { type1, type2, type3 };
